import { BaseModel } from "@/store/feathers/feathers.client.js";
/* eslint-disable no-useless-escape, no-unused-vars */

export default class Addresses extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Addresses";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      contact: null,
      is_host: false,
      street_1: null,
      street_2: null,
      street_3: null,
      city: null,
      state_code: null,
      state_name: null,
      county: null,
      postal_code: null,
      phone: null,
      line_1: null,
      line_2: null,
      formatted: null,
      timezone: null,
      region: null,
      import_id: null,
      deleted_at: null,
      kind: null,
      custom_fields: [],
      notes: [],
      tags: [],
      meta_data: {},
      latitude: null,
      longitude: null,
      country_code: store.state.config.default_country.country_code,
      flag: store.state.config.default_country.flag,
      postal_code_format: store.state.config.default_country.postal_mask,
      country_name: store.state.config.default_country.country_name,
      geoname_id: store.state.config.default_country.geoname_id,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      mid_id: null,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,

      // temps
      country: store.state.config.default_country
    }
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    return data;
  }
}
